import * as emailTemplatesServices from './emailTemplatesServices';

export { emailTemplatesServices };
